package io.horion.cv.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.components.Footer
import io.horion.cv.components.Topbar
import io.horion.cv.sections.*
import io.horion.cv.utils.Colors

@Page("/")
@Composable
fun HomePage() {

    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(if (isDark) Colors.DarkBG else Colors.White)
            .styleModifier {
                property("min-height", "100vh")
                property("transition", "background-color 300ms ease")
            },
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Topbar()
        HeroSection()
        ProcedureSection()
        ModelSection()
        CoverLetterHeroSection()
        MotivationLetterSection()
        CountrySection()
        TestimonialSection()
        Footer()
    }
}

